/**
 * Vocabulário de risco de tool — **fonte única** para todas as telas.
 *
 * Existia em cinco cópias (Approvals, AccessControl, Identities, Policies, Resources) e elas já
 * tinham divergido: `read` era `success` em quatro e `neutral` em Policies, então a mesma tool
 * aparecia verde numa tela e cinza noutra. O risco é atributo do catálogo, não da tela — quem o
 * exibe não decide a cor dele.
 *
 * Os quatro valores são o enum do §B3 do contrato do gateway; `desconhecido` é o estado de tool
 * que ninguém classificou ainda, e é neutro de propósito: risco que não se sabe não pode parecer
 * benigno nem alarmante.
 */
import { t } from './i18n';

export type RiscoExibido = 'read' | 'write' | 'high' | 'desconhecido';

export type TomDeBadge = 'success' | 'warning' | 'danger' | 'neutral';

export const RISK_TOM: Record<RiscoExibido, TomDeBadge> = {
  read: 'success',
  write: 'warning',
  high: 'danger',
  desconhecido: 'neutral',
};

/**
 * Rótulo exibido, do catálogo (`common.risk.*`).
 *
 * `read`/`write`/`high` são termo técnico do glossário e **ficam em inglês nos
 * dois locales** (decisão de copy de 08/09); só `desconhecido` traduz. Passar
 * pelo catálogo mesmo assim é o que impede a sexta cópia: era `Record<…,
 * string>` de módulo, e uma tabela de módulo é avaliada na importação — com o
 * seletor de idioma no ar, `desconhecido` ficaria preso ao idioma da carga.
 *
 * É função, e não tabela, pela mesma razão. O nome antigo (`RISK_LABEL`) sai
 * junto: um `const` que muda de valor entre chamadas mente sobre o que é.
 */
export function riskLabel(risco: RiscoExibido): string {
  return t(`common.risk.${risco}`);
}
